/**
 * WaveMark — inline SVG version of the favicon, designed to sit next to the
 * "WaveScorePro" wordmark. Inherits sizing from the parent font-size.
 * Use the `inverted` prop on dark backgrounds where the navy rounded tile
 * disappears — it flips to a transparent tile so the cyan→green wave reads
 * cleanly against the dark surface.
 */
export function WaveMark({ size = 26, inverted = false }) {
  const tile = inverted ? "transparent" : "#0A1628";
  return (
    <svg
      data-testid="wave-mark"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
    >
      <defs>
        <linearGradient id="wm-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00D4FF" />
          <stop offset="100%" stopColor="#00C896" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill={tile} />
      <g stroke="url(#wm-grad)" strokeWidth="4.5" strokeLinecap="round" fill="none">
        <path d="M8 36 Q14 18, 20 36 T32 36 T44 36 T56 36" />
      </g>
    </svg>
  );
}
